import type { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../parts/modal-new";
import type { ClientConfigRoleLabels } from "./i18n";

interface TurnOffGoalsConfirmModalProps {
  roleLabels: ClientConfigRoleLabels;
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const TurnOffGoalsConfirmModal = ({
  roleLabels,
  isVisible,
  onConfirm,
  onCancel,
}: TurnOffGoalsConfirmModalProps) => {
  const { t } = useTranslation(["athlete-portal", "common"]);

  if (!isVisible) return null;

  const handleOverlayClose = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onCancel();
  };

  return (
    <Modal
      className="turn-off-goals-confirm-modal"
      title={t("clientConfiguration.turnOffGoalsModal.title")}
      onClose={handleOverlayClose}
    >
      <div className="body">
        <p>{t("clientConfiguration.turnOffGoalsModal.body", roleLabels)}</p>
      </div>
      <footer className="client-config-footer-buttons">
        <div className="right-content">
          <button type="button" data-button-type="secondary" onClick={onCancel}>
            {t("common:cancel")}
          </button>
          <button
            type="button"
            data-button-type="danger"
            data-action="delete"
            onClick={onConfirm}
          >
            {t("clientConfiguration.turnOffGoalsModal.confirm")}
          </button>
        </div>
      </footer>
    </Modal>
  );
};
